import type { IconSvgObject } from './types';

const ParagraphSpacingIcon: IconSvgObject = [
  ["path", { d: "M3 2H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 22H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9.5 8.5L12 6L14.5 8.5M9.5 15.5L12 18L14.5 15.5M12 6.5V17.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ParagraphSpacingIcon;
